export default __webpack_public_path__ + "static/media/close.0287fb3a.svg";